var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43499 4.74729H5.61368C6.47239 4.74737 7.27106 4.30681 7.72904 3.58043L8.61918 2.16686C9.07716 1.44048 9.87583 0.999919 10.7345 1H13.6384C14.4971 0.999919 15.2957 1.44048 15.7537 2.16686L16.6439 3.58043C17.1018 4.30681 17.9005 4.74737 18.7592 4.74729H20.9379C22.3188 4.74729 23.4383 5.86677 23.4383 7.24771V18.4029C23.4347 19.8357 22.274 20.9963 20.8412 21H3.53167C2.09885 20.9963 0.938235 19.8357 0.93457 18.4029V7.24771C0.93457 5.86677 2.05405 4.74729 3.43499 4.74729Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1881 15.9993C14.2595 15.9993 15.9387 14.3201 15.9387 12.2487C15.9387 10.1773 14.2595 8.49805 12.1881 8.49805C10.1167 8.49805 8.4375 10.1773 8.4375 12.2487C8.4375 14.3201 10.1167 15.9993 12.1881 15.9993Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraDark);
export default __webpack_public_path__ + "static/media/camera-dark.abe001674625252e782628bacd9eaad9.svg";
export { ForwardRef as ReactComponent };